import '../globals.css';
import type { AppProps } from 'next/app';
import { ConfigProvider, App } from 'antd';
import { THEME_GENERAL } from 'tkmp-lib/src/themes';
import image_logo_icon from '/public/static/images/image_logo_icon.svg';
import Head from 'next/head';
import useLocalization from 'tkmp-lib/src/hooks/useLocalization';

import ruRU from 'antd/locale/ru_RU';
import enGB from 'antd/locale/en_GB';
import zhCN from 'antd/locale/zh_CN';

export default function ({ Component, pageProps }: AppProps) {
    const LOCALIZATION = useLocalization();

    const getLocale = () => {
        switch (LOCALIZATION.locale) {
            case 'ru':
                return ruRU;
            case 'en':
                return enGB;
            case 'cn':
                return zhCN;
            default:
                return ruRU;
        }
    };

    return (
        <>
            <Head>
                <title>Маркетплейс TKMP.Istok</title>
                <meta
                    name="robots"
                    content="noindex"
                />
                <link
                    rel="icon"
                    href={image_logo_icon.src}
                    sizes="any"
                />
                <link
                    rel="apple-touch-icon"
                    href={image_logo_icon.src}
                    sizes="any"
                />
                <meta
                    nonce=""
                    name="viewport"
                    data-hid="viewport"
                    content="width=device-width, height=device-height, minimum-scale=1.0, initial-scale=1.0"
                />
            </Head>
            <ConfigProvider
                theme={THEME_GENERAL}
                locale={getLocale()}
                wave={{ disabled: true }}
            >
                <App>
                    <Component {...pageProps} />
                </App>
            </ConfigProvider>
        </>
    );
}
